import axios from "@/utils/axios";
import { staticObj } from "./static";
import _ from "lodash";
export const selectData = _.cloneDeep(staticObj);
console.log(selectData);
// 字典项缓存函数
const selectKey = {
  teamLevel: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/团组级别`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  guestType: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/内外宾`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  homeGuest: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/内宾团组级别`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  foreignGuests: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/外宾团组级别`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  HongKong: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/港澳嘉宾团组级别`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  TAIWAN: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/台湾嘉宾团组级别`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  teamType: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/团组类别`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  underTokenPersons: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/礼遇标准`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  arrivePlace: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/抵达地点`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
  arriveWay: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/抵达方式`
    );
    return res.data.map((item) => ({
      value: item.paramCode,
      label: item.paramName,
    }));
  },
  leaveWay: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/返程方式`
    );
    return res.data.map((item) => ({
      value: item.paramCode,
      label: item.paramName,
    }));
  },
  cardType: async () => {
    const res = await axios.get(
      `/suncn-base-system/system/param/business/getBusinessListByGroupName/证件类型`
    );
    return res.data.map((item) => ({
      value: item.paramName,
      label: item.paramName,
    }));
  },
};
// 获取公共数据字典
const publicDic = async function (params) {
  const res = await axios.post("/system/param/public/getListByGroupName", {
    ...params,
  });
  const list = res?.data?.data;
  return list.map((item) => {
    return {
      value: item.paramCode,
      label: item.paramName,
      easyLabel: item.paramSimpleName,
    };
  });
};
// forceRefresh 强制刷新标识
export async function getSelect(item, forceRefresh = false) {
  const isString = typeof item === "string";
  const key = isString ? item : item?.key; // 判断当前传入类型 获取字段key
  // 通过key获取option方法内部
  if (!forceRefresh && selectData[key]) {
    // 首先判断是否缓存过该数据，如果缓存了 则直接从缓存中读取
    return selectData[key]; // 返回缓存的值
  } else {
    if (isString) {
      selectData[key] = await selectKey[key](); // 更新缓存
    } else {
      selectData[key] = publicDic(item);
    }
    return selectData[key]; // 返回缓存的值
  }
}
// 重置字典
export const resetDict = function (name) {
  if (!name) {
    // 如果name为空，则重置所有字典
    for (const key in selectData) {
      if (Object.hasOwnProperty.call(selectData, key)) {
        delete selectData[key];
      }
    }
    Object.assign(selectData, staticObj);
  } else {
    selectData[name] = null;
  }
};


export function getCurrentDateTime() {
  const now = new Date();
  
  // 获取年月日
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  
  // 获取星期几
  const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  const weekDay = weekDays[now.getDay()];
  
  // 获取时间段（上午/下午/晚上）
  const hour = now.getHours();
  let timePeriod = '晚上';
  if (hour < 12) {
    timePeriod = '上午';
  } else if (hour < 18) {
    timePeriod = '下午';
  }
  
  // 获取小时和分钟
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  return {
    date: `${year}年${month}月${day}日`,
    year,
    month,
    day,
    weekDay,
    timePeriod,
    time: `${hours}:${minutes}:${seconds}`,
    hour: hours,
    minute: minutes,
    second: seconds,
    fullDateTime: `${year}-${month}-${day} ${weekDay} ${timePeriod} ${hours}:${minutes}:${seconds}`
  };
}
